import { render, staticRenderFns } from "./chapter-select-component.vue?vue&type=template&id=4e66a7ce&scoped=true&"
import script from "./chapter-select-component.vue?vue&type=script&lang=ts&"
export * from "./chapter-select-component.vue?vue&type=script&lang=ts&"
import style0 from "./chapter-select-component.vue?vue&type=style&index=0&id=4e66a7ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e66a7ce",
  null
  
)

export default component.exports